import { render } from "./cardDialog.vue?vue&type=template&id=35164cc1"
import script from "./cardDialog.vue?vue&type=script&lang=js"
export * from "./cardDialog.vue?vue&type=script&lang=js"

import "./cardDialog.vue?vue&type=style&index=0&id=35164cc1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__